import { IconFileRegular } from '@smartbear/swagger-portal-component-library'

import { CommonSearchResultTile, HighlightedTitle } from '../CommonSearchResultTile'
import { SearchResult } from '~/portal/types/search'

interface DocumentSearchResultTileProps {
  result: SearchResult
  onClose: () => void
  tileKey: string
}

export const DocumentSearchResultTile = ({ result, onClose, tileKey }: DocumentSearchResultTileProps) => {
  const url = `/${result.product.slug}/${result.href}`

  const titleContent = <HighlightedTitle titleSnippet={result.titleSnippet} />

  return (
    <CommonSearchResultTile
      result={result}
      onClose={onClose}
      tileKey={tileKey}
      icon={<IconFileRegular />}
      url={url}
      titleContent={titleContent}
    />
  )
}
